export const taglineText = 'Your flow, unlocked';
